<template>
  <div class="dropdown more-filters float-right btn-group" role="group" aria-expanded="false" ref='dropdown' v-click-outside='closeDropdown'>
    <button @click='showFilter = null' class="btn btn-neutral" type="button" data-toggle="dropdown">
      {{ $t('root.filters.more_filters') }}
    </button>

    <div class="dropdown-menu">
      <div v-show='!showFilter'>
        <input v-model='q' type="search" class="form-control" />

        <ul>
          <li v-for='(name, filter) in filteredFilterList' :key='filter' @click='showFilter = filter' class="dropdown-item">
            {{ name }}
          </li>
        </ul>
      </div>

      <component v-if='showFilter' :is="'filter-items-by-' + showFilter" :folder='folder' @cancel='showFilter = null' />
    </div>
  </div>
</template>

<script>
  import _filter_items_by_shared from './_filter_by_shared'
  import _filter_items_by_version from './_filter_by_version'
  import _filter_items_by_star from './_filter_by_star'
  import _filter_items_by_type from './_filter_by_type'
  import _filter_items_by_contact from './_filter_by_contact'
  import _filter_items_by_checklist from './_filter_by_checklist'
  import _filter_items_by_ocr from './_filter_by_ocr'
  import _filter_items_by_subscription from './_filter_by_subscription'
  import _filter_items_by_mime from './_filter_by_mime'
  import _filter_items_by_exp_status from './_filter_by_exp_status'
  import _filter_items_by_exp_date from './_filter_by_exp_date'
  import _filter_items_by_size from './_filter_by_size'
  import _filter_items_by_progress from './_filter_by_progress'
  import _filter_items_by_tag from './_filter_by_tag'
  import _filter_items_by_product from './_filter_by_product'
  import _filter_items_by_document from './_filter_by_document'
  import _filter_items_by_uploaded_from from './_filter_by_uploaded_from'
  import _filter_items_by_folder from "./_filter_by_folder";

  export default {
    components: {
      'filter-items-by-shared': _filter_items_by_shared,
      'filter-items-by-star': _filter_items_by_star,
      'filter-items-by-version': _filter_items_by_version,
      'filter-items-by-klass': _filter_items_by_type,
      'filter-items-by-contact': _filter_items_by_contact,
      'filter-items-by-checklist': _filter_items_by_checklist,
      'filter-items-by-ocr': _filter_items_by_ocr,
      'filter-items-by-subscription': _filter_items_by_subscription,
      'filter-items-by-mime': _filter_items_by_mime,
      'filter-items-by-expstatus': _filter_items_by_exp_status,
      'filter-items-by-expdate': _filter_items_by_exp_date,
      'filter-items-by-filesize': _filter_items_by_size,
      'filter-items-by-progress': _filter_items_by_progress,
      'filter-items-by-tag': _filter_items_by_tag,
      'filter-items-by-product': _filter_items_by_product,
      'filter-items-by-document': _filter_items_by_document,
      'filter-items-by-uploaded_from': _filter_items_by_uploaded_from,
      'filter-items-by-folder_name': _filter_items_by_folder,
    },
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
    mounted() {
      $(this.$refs.dropdown).on('hide.bs.dropdown', () => {
        if (!this.isClosable)
          return false

        this.isClosable = false
        return true
      })
    },
    data() {
      return {
        q: '',
        showFilter: null,
        isClosable: false,
      }
    },
    computed: {
      upperQ() {
        return this.q.toUpperCase()
      },
      filterList() {
        return {
          progress: this.$t('root.filters.checklist_progress'),
          checklist: this.$t('root.filters.has_checklist'),
          contact: this.$t('root.filters.contact_connection'),
          document: this.$t('root.filters.documents'),
          expdate: this.$t('root.filters.expiration_date'),
          expstatus: this.$t('root.filters.expstatus'),
          ocr: this.$t('root.filters.ocr'),
          filesize: this.$t('root.filters.size'),
          mime: this.$t('root.filters.mime'),
          folder_name: this.$t('root.filters.folder_name'),
          product: this.$t('root.filters.products'),
          klass: this.$t('root.filters.show_only'),
          shared: this.$t('root.filters.shared_status'),
          star: this.$t('root.filters.star_status'),
          subscription: this.$t('root.filters.subscribed'),
          tag: this.$t('root.filters.tags'),
          uploaded_from: this.$t('root.filters.uploaded_from'),
          version: this.$t('root.filters.version'),
        }
      },
      filteredFilterList() {
        if (this.q.length < 1)
          return this.filterList

        const fs = {}
        Object.keys(this.filterList).forEach((k) => {
          const v = this.filterList[k]

          if (v.toUpperCase().indexOf(this.upperQ) >= 0)
            fs[k] = v
        })
        return fs
      },
    },
    methods: {
      closeDropdown() {
        if (this.$refs.dropdown.classList.contains('show'))
          this.isClosable = true
      },
    }
  }
</script>
<style lang="sass" scoped>
  .dropdown-menu
    padding: 10px
    .dropdown-item
      cursor: pointer
  .more-filters
    position: relative
    .btn.btn-neutral
      border-radius: 3px
    .dropdown-menu
      transform: none!important
      top: 45px!important
</style>
